export default "__VITE_ASSET__9694b177__"